import { css, SerializedStyles } from '@emotion/react';

import { Theme } from '@shipengine/giger-theme';

export const getInputStyles = (): SerializedStyles =>
    css({
        display: 'none',
    });

export const getUpsellWrapperStyles = (theme: Theme): SerializedStyles =>
    css({
        cursor: 'pointer',
        padding: theme.spacing(2),
        borderRadius: theme.spacing(),
        border: `1px solid ${theme.palette.black}`,

        ':not(:first-of-type)': {
            marginLeft: theme.spacing(),
        },
    });

export const getUpsellWrapperSelectedStyles = (theme: Theme): SerializedStyles =>
    css({
        cursor: 'initial',
        color: theme.palette.white,
        border: '1px solid transparent',
        backgroundColor: theme.palette.primary.main,
    });
